<template>
  <div style="margin: 2%;">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="juli">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/map_mn/Map_mn' }">地图管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/map_mn/Line_mn' }">线路管理</el-breadcrumb-item>
      <el-breadcrumb-item>站点管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="站点详情" name="first">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column label="ID" align="center" width="80">
          </el-table-column>
          <el-table-column prop="station_id" label="站点编号" align="center" width="180">
          </el-table-column>
          <el-table-column prop="station_name" label="站点名称" align="center" width="180">
          </el-table-column>
          <el-table-column prop="create_time" align="center" label="创建时间" width="250">
          </el-table-column>
          <el-table-column prop="update_time" align="center" label="更新时间" width="250">
          </el-table-column>
          <el-table-column align="center" label="状态" width="150">
            <el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949">
            </el-switch>
          </el-table-column>

          <el-table-column prop="remarks" align="center" label="备注">
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="站点地图" name="second">
        <div id="containermap"></div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

  // import AMap from "AMap";
  // let conmap = "";
  import AMapLoader from "@amap/amap-jsapi-loader";
  let conmap = "";
  export default {
    data() {
      return {
        activeName: "first",
        map: null,
        value: true,
        tableData: [
          {
            station_id: "01",
            station_name: "02",
            create_time: "2022-01-02",
            update_time: "2022-01-02",
            remarks: "10101010101",
          },
        ],
      };
    },
    mounted() {
      this.createMap();
    },
    methods: {
      handleClick() { },
      createMap() {
        //创建地图
        AMapLoader.load({
          key: "872899e98d8b442ed41d45612fd91d4b", // 申请好的Web端开发者Key，首次调用 load 时必填
          version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
          plugins: "" // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        }).then(AMap => {
          // var center_path = result.locations;
          conmap = new AMap.Map("containermap", {
            //设置地图容器id
            viewMode: "3D", //是否为3D地图模式
            zoom: 15, //初始化地图级别
            center: [116.397428, 39.90923]//中心点坐标,//初始化地图中心点位置
            // mapStyle: 'amap://styles/blue', //设置地图的显示样式
          });
          // var lnglat = [116.397428, 39.90923];
          // AMap.convertFrom(lnglat, "gps", function (status, result) {
          //   if (result.info === "ok") {
          //     var resLnglat = result.locations[0];
          //     let m2 = new AMap.Marker({
          //       position: resLnglat
          //     });
          //     conmap.add(m2);
          //     // 设置标签
          //     m2.setLabel({
          //       offset: new AMap.Pixel(20, 20)
          //     });
          //   }
          // });
        });
        // conmap = new AMap.Map("containermap", {
        //   resizeEnable: true, //是否监控地图容器尺寸变化
        //   zoom: 25, //初始化地图层级
        //   center: [118.054994, 36.813787], //初始化地图中心点
        // });
        // this.guiji()
      },
      // guiji() {
      //   // AMapUI.load(
      //   //   ["ui/misc/PathSimplifier", "lib/$"],
      //   //   function (PathSimplifier, $) {
      //   //     if (!PathSimplifier.supportCanvas) {
      //   //       alert("当前环境不支持 Canvas！");
      //   //       return;
      //   //     }

      //   //     var pathSimplifierIns = new PathSimplifier({
      //   //       zIndex: 10,
      //   //       //autoSetFitView:false,
      //   //       map: conmap, //所属的地图实例

      //   //       getPath: function (pathData, pathIndex) {
      //   //         return pathData.path;
      //   //       },
      //   //       getHoverTitle: function (pathData, pathIndex, pointIndex) {
      //   //         if (pointIndex >= 0) {
      //   //           //point
      //   //           return (
      //   //             pathData.name +
      //   //             "，点：" +
      //   //             pointIndex +
      //   //             "/" +
      //   //             pathData.path.length
      //   //           );
      //   //         }

      //   //         return pathData.name + "，点数量" + pathData.path.length;
      //   //       },
      //   //       renderOptions: {
      //   //         renderAllPointsIfNumberBelow: 100, //绘制路线节点，如不需要可设置为-1
      //   //       },
      //   //     });

      //   //     window.pathSimplifierIns = pathSimplifierIns;

      //   //     //设置数据
      //   //     pathSimplifierIns.setData([
      //   //       {
      //   //         name: "路线0",
      //   //         path: [
      //   //           [116.405289, 39.904987],
      //   //           [113.964458, 40.54664],
      //   //           [111.47836, 41.135964],
      //   //           [108.949297, 41.670904],
      //   //           [106.380111, 42.149509],
      //   //           [103.774185, 42.56996],
      //   //           [101.135432, 42.930601],
      //   //           [98.46826, 43.229964],
      //   //           [95.777529, 43.466798],
      //   //           [93.068486, 43.64009],
      //   //           [90.34669, 43.749086],
      //   //           [87.61792, 43.793308],
      //   //         ],
      //   //       },
      //   //     ]);

      //   //     //对第一条线路（即索引 0）创建一个巡航器
      //   //     var navg1 = pathSimplifierIns.createPathNavigator(0, {
      //   //       loop: true, //循环播放
      //   //       speed: 1000000, //巡航速度，单位千米/小时
      //   //     });

      //   //     navg1.start();
      //   //   }
      //   // );
      // },
    },
  };
</script>

<style>
  #containermap {
    width: 100%;
    height: 700px;
  }

  .juli {
    margin-bottom: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/views/map_mn/Station_mn.vue